import React from 'react'
import styled from 'styled-components'

const BedroomsContainer = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  align-self: ${props => (props.isGrid ? 'flex-end' : 'flex-start')};
  margin-bottom: 2px;
`

const Bedrooms = ({ isGrid, bedrooms }) => {
  if (bedrooms.length === 0) {
    return <BedroomsContainer isGrid={isGrid}>No bedrooms available</BedroomsContainer>
  }

  const startingAtText = isGrid ? '' : ', starting at'

  if (bedrooms.length === 1) {
    if (bedrooms[0] === 0) {
      return <BedroomsContainer isGrid={isGrid}>Studio{startingAtText}</BedroomsContainer>
    }

    if (bedrooms[0] === 1) {
      return <BedroomsContainer isGrid={isGrid}>1 bedroom{startingAtText}</BedroomsContainer>
    }

    return (
      <BedroomsContainer
        isGrid={isGrid}
      >{`${bedrooms[0]} bedrooms${startingAtText}`}</BedroomsContainer>
    )
  }

  const range = `${Math.min(...bedrooms)}-${Math.max(...bedrooms)}`

  return (
    <BedroomsContainer isGrid={isGrid}>{`${range} bedrooms${startingAtText}`}</BedroomsContainer>
  )
}

export default Bedrooms
